module.exports = __webpack_public_path__ + "img/icon-climbs.0ee175ae.svg";